export const LONGITUDE_REGEX =
  /^(\+|-)?(?:180(?:(?:\.0{1,8})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]*)?))$/;

export const LONGITUDE_OCPI_REGEX = /^-?[0-9]{1,3}\.[0-9]{5,7}$/;
